<template>
  <svg
    class="custom-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6066 4.22189C23.3877 3.44085 23.3876 2.17451 22.6066 1.39347C21.8256 0.612418 20.5592 0.612418 19.7782 1.39347L12 9.17164L4.22183 1.39346C3.44078 0.612416 2.17445 0.612416 1.3934 1.39346C0.612352 2.17451 0.612351 3.44084 1.3934 4.22189L9.17157 12.0001L1.3934 19.7782C0.61235 20.5593 0.612351 21.8256 1.3934 22.6067C2.17445 23.3877 3.44078 23.3877 4.22183 22.6067L12 14.8285L19.7782 22.6067C20.5592 23.3877 21.8256 23.3877 22.6066 22.6067C23.3877 21.8256 23.3877 20.5593 22.6066 19.7782L14.8284 12.0001L22.6066 4.22189Z"
    />
  </svg>
</template>
